(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /**
     * Used to share code.
     */
    window.carbon = window.carbon || {};

    /**
     * Get the current page/post/{post_type} ID.
     */
    carbon.currentPostId = function () {
        var id = 0;
        document.body.classList.forEach(function (v) {
            if (-1 !== v.indexOf('postid-')) id = v.split('-')[1];
            if (-1 !== v.indexOf('page-id-')) id = v.split('-')[2];
        });
        return id;
    };

    // reset CF7 form
    carbon.resetForm = function (formElem) {
        if (!formElem) return;
        // fixes issue with CF7 5.4, @see https://wordpress.org/support/topic/resetting-form-after-ajax-form-submit/
        // formElem.reset();
        formElem.setAttribute('data-status', 'init');
        formElem.classList.remove('sent');
        formElem.classList.remove('invalid');
        formElem.classList.add('init');
        formElem.querySelector('input[name="_wpcf7_posted_data_hash"]').value = '';
        formElem.querySelector('.wpcf7-response-output').innerHTML = '';
        formElem.querySelectorAll('.wpcf7-not-valid-tip').forEach(function (elem) {
            elem.innerHTML = '';
        });
    };

    /**
     * CustomEvent() constructor polyfill
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
     * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
     */
    (function () {
        if ('function' === typeof window.CustomEvent) return false;
        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: null };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(
                event,
                params.bubbles,
                params.cancelable,
                params.detail
            );
            return evt;
        }
        window.CustomEvent = CustomEvent;
    })();

    /**
     * Element.closest( selector ) polyfill
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#polyfill
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#polyfill
     */
    (function () {
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;
        }
        if (!Element.prototype.closest) {
            Element.prototype.closest = function (s) {
                var el = this;
                do {
                    if (el.matches(s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);
                return null;
            };
        }
    })();

    // check if the DOM is loaded, then run ready()
    function ready(callbackFunc) {
        if (document.readyState !== 'loading') {
            callbackFunc();
        } else if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', callbackFunc);
        } else {
            // Old IE browsers
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete') {
                    callbackFunc();
                }
            });
        }
    }

    ready(function () {
        document.querySelector('main');
        document.querySelector('footer');

        const header_check = function () {
            let headlines = document.querySelectorAll('h1');
            if (!headlines) return;
            for (let instance of headlines) {
                let this_length = instance.innerText.length;
                // always an arbitrary number....
                if (this_length > 63) {
                    instance.className += ' long-title';
                }
            }
        };
        header_check();

        const all_frames = function () {
            let iframes = document.querySelectorAll('iframe');
            if (!iframes) return;
            // https://github.com/davidjbradshaw/iframe-resizer/issues/443
            // In other words, not really an error, and shouldn't prevent execution.
            for (let i = 0; i < iframes.length; i++) {
                iFrameResize([
                    {
                        checkOrigin: false,
                        heightCalculationMethod: 'bodyOffset',
                    },
                ]);
            }
        };
        all_frames();

        const wrap_tables = function () {
            const tables = document.querySelectorAll('table:not(.carbon-table)');

            if (!tables.length) {
                return;
            }

            tables.forEach((table) => {
                if (!table.parentElement.classList.contains('c-table-wrap')) {
                    const wrapper = document.createElement('div');
                    wrapper.setAttribute('class', 'c-table-wrap');

                    const parent = table.parentElement;

                    parent.insertBefore(wrapper, table);
                    wrapper.appendChild(table);
                }
            });
        };
        wrap_tables();

        const site_search_name = function () {
            let search_form = document.querySelector('.search-form');
            if (!search_form) return;
            search_form.setAttribute('name', 'site-search');
        };
        site_search_name();

        const cf7_form_name = function () {
            let cf7forms = document.querySelectorAll('.wpcf7-form');
            if (!cf7forms) return;
            for (let i = 0; i < cf7forms.length; i++) {
                if (cf7forms[i].getAttribute('name')) continue;
                let id_field = cf7forms[i].querySelector('input[name="form_id"]');
                if (!id_field) continue;
                let form_id = id_field.getAttribute('value');
                cf7forms[i].setAttribute('name', form_id);
            }
        };
        cf7_form_name();
    });

    // TODO: gulp minify is not removing comments! only /**/ should be output, not // (then cleanup the /**/)

}));
